export const SOCIAL_AUTH_PATH = '/api/v1/third-party-auth/social-auth';
